import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { useCallback } from 'react';
import uuid from 'react-uuid';
import Button from 'src/components/design-system/Button';
import useViewBudgetPeriod from 'src/hooks/useViewBudgetPeriod';
import { round } from 'src/utils';
import { truncatedTwoDecimalNumber } from 'src/utils/number';

const distributionList = ['Percentage', 'Amount'];

const ViewBudgetPeriodToolBar = () => {
  const { setBudgetPeriods, poDetails, distributionType, setDistributionType, t } =
    useViewBudgetPeriod();

  const handleAddRow = useCallback(() => {
    setBudgetPeriods((prev) => {
      const rows = [...prev];
      const newRow = {
        glPeriodId: 0,
        percentageAmount: 0,
        amount: 0,
        isDeletable: true,
        expanded: false,
        rowId: uuid(),
        items: [],
        isNew: true,
        isClosed: 0,
      };
      return [...rows, newRow];
    });
  }, [setBudgetPeriods]);

  const handleAutoDistribututionBalance = useCallback(() => {
    setBudgetPeriods((prev) => {
      const prevData = [...prev];
      const total = prevData.length;
      const amount = truncatedTwoDecimalNumber(poDetails.poTotal / total);
      let remainingAmount = round(poDetails.poTotal - amount * total, 2);

      const newData = prevData.map((item) => {
        let newAmount = amount;
        if (remainingAmount > 0) {
          newAmount = round(newAmount + 0.01, 2);
          remainingAmount = round(remainingAmount - 0.01, 2);
        } else if (remainingAmount < 0) {
          newAmount = round(newAmount - 0.01, 2);
          remainingAmount = round(remainingAmount + 0.01, 2);
        }
        const percentage = round((newAmount / poDetails.poTotal) * 100, 2);
        return {
          ...item,
          percentageAmount: percentage,
          amount: newAmount,
          items: item.items.map((lineItem) => {
            const distributionAmount = round(lineItem.totalAmount * (percentage / 100), 2);
            return {
              ...lineItem,
              endingBalanceAmount: lineItem.beginBalanceAmount - distributionAmount,
              distributionPercentage: percentage,
              distributionAmount,
            };
          }),
        };
      });
      return newData;
    });
  }, [poDetails?.poTotal, setBudgetPeriods]);

  const handleChange = useCallback(
    (e: DropDownListChangeEvent) => {
      setDistributionType(e.value);
    },
    [setDistributionType]
  );

  return (
    <div className="flex items-center justify-between w-full text-[13px]">
      <div className="flex gap-2">
        <Button onClick={handleAddRow}>{t('Add New Row')}</Button>
        <Button onClick={handleAutoDistribututionBalance}>{t('Distribute Equally')}</Button>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-white">{t('Distribute By')} </span>
        <DropDownList
          id="view-drop-down-list"
          style={{ width: 150 }}
          data={distributionList}
          value={distributionType}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};
export default ViewBudgetPeriodToolBar;
